import { restClient } from '../../client';
import { Appointment } from '../../resources';


export const getAppointmentBefore = async (patientId: string, datetime: string) => {
  return restClient.request<{ data: Appointment | null }>('/api/v1/appointment-before', {
    params: {
      patient_id: patientId,
      datetime: datetime,
    }
  });
};
